module.exports = __webpack_public_path__ + "media/images/riders/small/CHARLIE_HATTON-193216105b5b80c9d212e3951d83cc5a.png";